module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title-banner":"the stage<br /> is yours","subtitle-banner":"Come and discover the Sonotron and<br /> its workshops open to all.","all":"All","from":"From","to":"To"},"fr":{"title-banner":"the stage<br /> is yours","subtitle-banner":"Venez découvrir le Sonotron et<br /> ses workshops ouverts à tous.","all":"Tout","from":"Du","to":"Au"}}')
  delete Component.options._Ctor
}
